import { TabData } from '@ddt-web/data-service';

export function extractAsOfDateFromMultiplePortfolios(asOfDateTab: TabData): string {
	return (asOfDateTab?.tableData?.[0]?.cells || [])
		.map(portfolioAsOfDate => portfolioAsOfDate?.[0]?.formattedValue)
		.find(Boolean); // For multiple portfolios, make sure we take the as of date from a portfolio response that does have ESG data.
}
